import { Box, Button, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { DESIGN_TOKENS } from '../../styles/theme';
import { getTransportFacts } from '../../utils/constants';
import { useI18n } from '../../i18n';

interface NoConnectionDisplayProps {
  onRetry?: () => void;
}

export function NoConnectionDisplay({ onRetry }: NoConnectionDisplayProps) {
  const { t } = useI18n();
  const transportFacts = getTransportFacts();
  const randomFact = transportFacts[Math.floor(Math.random() * transportFacts.length)];

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${DESIGN_TOKENS.colors.primaryLighter}30, ${DESIGN_TOKENS.colors.surface})`,
        py: 8,
        px: 2,
        borderRadius: DESIGN_TOKENS.borderRadius.card,
        border: `1px solid ${DESIGN_TOKENS.colors.border}`,
      }}
    >
      <Box sx={{ textAlign: 'center', maxWidth: 600 }}>
        {/* Offline display */}
        <Box
          sx={{
            fontSize: { xs: '6rem', md: '8rem' },
            fontWeight: 900,
            lineHeight: 0.9,
            fontFamily: DESIGN_TOKENS.typography.fontFamilyDisplay,
            background: `linear-gradient(135deg, ${DESIGN_TOKENS.colors.errorLight}, ${DESIGN_TOKENS.colors.error})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 2,
            letterSpacing: '-0.04em',
            userSelect: 'none',
          }}
        >
          OFFLINE
        </Box>

        <WifiOffIcon sx={{ fontSize: 56, color: DESIGN_TOKENS.colors.errorLight, mb: 2 }} />

        <Typography variant="h3" sx={{ mb: 1.5 }}>{t('offline.title')}</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>{t('offline.description')}</Typography>

        <Box
          sx={{
            p: 3,
            backgroundColor: DESIGN_TOKENS.colors.surface,
            borderRadius: DESIGN_TOKENS.borderRadius.card,
            border: `1px solid ${DESIGN_TOKENS.colors.border}`,
            mb: 4,
            textAlign: 'left',
          }}
        >
          <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700, mb: 1, display: 'block' }}>{t('offline.factTitle')}</Typography>
          <Typography variant="body2" sx={{ lineHeight: 1.65 }}>
            {randomFact}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          {onRetry && (
            <Button
              variant="contained"
              onClick={onRetry}
              size="large"
              sx={{ px: 4 }}
            >{t('common.retry')}</Button>
          )}
          <Button
            variant="outlined"
            onClick={() => window.location.reload()}
            size="large"
            sx={{ px: 4 }}
          >{t('offline.refresh')}</Button>
        </Box>
      </Box>
    </Box>
  );
}
